<mat-chip-set class="sg-ui-component">
  @if (isAllSelected) {
  <mat-chip [removable]="true" (removed)="removeAllOptions()" class="sg-ui-component">
    <span class="mat-chip-label">All selected</span>
    <mat-icon matChipRemove class="remove-icon">close</mat-icon>
  </mat-chip>
  } @if (!isAllSelected && values.length > 1) {
  <mat-chip class="aggregate-chip sg-ui-component" [removable]="true" (removed)="removeAllOptionsExceptLast()">
    <mat-icon class="stack-icon">sg-stack</mat-icon>
    <mat-icon class="stack-icon">sg-stack</mat-icon>
    <span class="aggregate-chip-value">
      <span>{{ values.length -1 }}</span>
      <mat-icon matChipRemove class="remove-icon">close</mat-icon>
    </span>
  </mat-chip>
  <mat-chip class="sg-ui-component" [removable]="true" (removed)="deselectOptions.emit([values[values.length-1]])">
    <span class="mat-chip-label">{{ values[values.length-1].label }}</span>
    <mat-icon matChipRemove class="remove-icon">close</mat-icon>
  </mat-chip>
  } @if (!isAllSelected && values.length === 1) {
  <mat-chip class="sg-ui-component" [removable]="true" (removed)="deselectOptions.emit([values[0]])">
    <span class="mat-chip-label">{{ values[0].label }}</span>
    <mat-icon matChipRemove class="remove-icon">close</mat-icon>
  </mat-chip>
  }
</mat-chip-set>
